import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const signals = [
    {
      icon: "Shield",
      title: "Secure Payment",
      description: "256-bit SSL encryption protects your payment information",
      color: "var(--color-success)"
    },
    {
      icon: "Award",
      title: "Quality Guaranteed",
      description: "Third-party tested for purity and authenticity",
      color: "var(--color-primary)"
    },
    {
      icon: "Truck",
      title: "Fast Shipping",
      description: "Free shipping on orders over $100",
      color: "var(--color-secondary)"
    },
    {
      icon: "RotateCcw",
      title: "30-Day Returns",
      description: "Money-back guarantee if not satisfied",
      color: "var(--color-accent)"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {signals?.map((signal, index) => (
        <div
          key={index}
          className="p-6 rounded-xl bg-card border border-border text-center space-y-3 transition-all duration-250 hover:border-primary hover:shadow-lg hover:shadow-primary/20"
        >
          <div className="w-12 h-12 mx-auto rounded-lg bg-muted border border-border flex items-center justify-center">
            <Icon name={signal?.icon} size={24} color={signal?.color} />
          </div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">
            {signal?.title}
          </h3>
          <p className="text-sm text-muted-foreground">
            {signal?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;